import type { User } from "firebase/auth"

/**
 * Apple sign-in exposes its stable user id (the Apple `sub`, aka the "apple
 * token") under `providerData`, not as `uid`. Returns it only for Apple
 * accounts, otherwise null. The Firebase uid stays the canonical identifier.
 */
export function getAppleToken(user: Pick<User, "providerData">): string | null {
  return user.providerData.find((p) => p?.providerId === "apple.com")?.uid ?? null
}
